<template>
    <div class="payload">
        <div class="d-flex align-items-center align-content-center justify-content-start">
            <BlockPicker :flatted-diagram="flattedDiagram" v-model="payload.blockId" :isGotoStep="isGotoStep" />
        </div>
    </div>
</template>

<script>
import BlockPicker from "../pickers/BlockPicker";

export default {
    name: "GotoStep",
    components: { BlockPicker },
    props: ["value", "flattedDiagram", "isGotoStep"],
    data() {
        return {
            payload: this.value,
            query: "",
        };
    },
    watch: {
        payload: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    methods: {
        chatbotBlockTypeTKey(type) {
            return "chatbotv2." + type;
        },
    },
    computed: {
        filteredSteps() {
            if (!!this.query) {
                let regx = new RegExp(this.query.toLowerCase(), "gi");
                return this.flattedDiagram
                    .filter((x) => x.type !== "GO_TO_STEP" && Object.keys(x).some((y) => regx.test(x[y])))
                    .map((x) => ({ text: x.name || this.$t(this.chatbotBlockTypeTKey(x.type)), value: x.id }));
            }
            return this.flattedDiagram
                .filter((x) => x.type !== "GO_TO_STEP")
                .map((x) => ({ text: x.name || this.$t(this.chatbotBlockTypeTKey(x.type)), value: x.id }));
        },
    },
};
</script>

<style scoped></style>
